var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TemplateComposer__preview_sms"},[_c('div',{staticClass:"message-sms"},[_c('p',{staticClass:"message-content"},[_vm._v(_vm._s(_vm.messagePreview))])])])}
var staticRenderFns = []

export { render, staticRenderFns }